"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.default = theme => ({
    root: {
        backgroundColor: theme.grey8,
        position: 'fixed',
        zIndex: constants_1.ASIDE_FIXED_ZINDEX,
        width: `calc(100% - 14px)`,
        maxWidth: constants_1.ASIDE_MAX_WIDTH,
        height: `calc(100% - ${constants_1.HEADER_HEIGHT}px)`,
        top: constants_1.HEADER_HEIGHT,
        right: 0,
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingRight: 'env(safe-area-inset-right)',
        overflow: 'auto',
        boxShadow: `-2px 0 4px 0 rgba(52, 50, 58, 0.2)`,
        '-webkit-overflow-scrolling': 'touch',
        transform: 'translateX(100%)',
        transition: 'transform 100ms ease-in-out 0ms',
        '&[aria-expanded="true"]': {
            transform: 'translateX(0)'
        }
    },
    content: {
        padding: 14
    },
    placeholder: {
        display: 'none'
    },
    '@media (min-width: 420px)': {
        root: {
            width: constants_1.ASIDE_MAX_WIDTH
        },
        placeholder: {
            display: 'block',
            width: constants_1.ASIDE_MAX_WIDTH,
            flexShrink: 0
        }
    }
});
//# sourceMappingURL=kanban.aside.style.js.map